export default __webpack_public_path__ + "static/media/dreamstime_s_98438134.8f46de68.jpg";